import { render, staticRenderFns } from "./addUploadImgPage.vue?vue&type=template&id=b4c523f6&"
import script from "./addUploadImgPage.vue?vue&type=script&lang=js&"
export * from "./addUploadImgPage.vue?vue&type=script&lang=js&"
import style0 from "./addUploadImgPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4c523f6')) {
      api.createRecord('b4c523f6', component.options)
    } else {
      api.reload('b4c523f6', component.options)
    }
    module.hot.accept("./addUploadImgPage.vue?vue&type=template&id=b4c523f6&", function () {
      api.rerender('b4c523f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/factory/afterSale/addUploadImgPage.vue"
export default component.exports